import { render, staticRenderFns } from "./TabCompleted.vue?vue&type=template&id=74cf0b84"
import script from "./TabCompleted.vue?vue&type=script&lang=js"
export * from "./TabCompleted.vue?vue&type=script&lang=js"
import style0 from "./TabCompleted.vue?vue&type=style&index=0&id=74cf0b84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports